/**
 * Created by RoryHe on 2020/10/9.
 */
import Vue from 'vue';
// 动态化组件，报错这里不要管，不要格式化！！！
const Header = () => import('./com-header.vue');
const Userinfo = () => import('./com-userinfo.vue');
const ComTitleH1 = () => import('./com-title-h1.vue');
const ComTabs = () => import('./com-tabs.vue');
const ImgHead = () => import('./img-head');
const ComTable = () => import('./com-table');
const ComFormCard = () => import('./com-form-card');
const singleUploadDialog = () => import('./single-upload-dialog');
const brtTooltip = () => import('./brt-tooltip');
const ComTag = () => import('./com-tag');
// const SvgIcon = () => import('./SvgIcon')
const comBreadcrumb = () => import('./com-breadcrumb.vue');
const comCircularRing = () => import('./com-circular-ring.vue');
const comSearch = () => import('./com-search.vue');
const comSelectBig = () => import('./com-select-big.vue');
const subDividing = () => import('./sub-dividing');
const comScrollbar = () => import('./com-scrollbar');
const comSearchTags = () => import('./com-search-tags');
const ComQuery = () => import('./com-query');
const ComProgress = () => import('./com-progress');
const comOperation = () => import('./com-operation');
const comTipCard = () => import('./com-tip-card');
const comWatermark = () => import('./com-watermark');
// 筛选列表
const ComFilterList = () => import('./com-filter-list');
// 小号的没数据
const ComNoValue = () => import('./com-no-value');
const ComMessageBox = () => import('./com-message-box');
const SuperQuery = () => import('./super-query');
const SelectTree = () => import('./select-tree');
const ComSignQrcode = () => import('./com-sign-qrcode');
const ComForm = () => import('./com-form');
const ComQueryPanel = () => import('./com-query-panel');
const ComSelect = () => import('./com-select');
const ComSideBox = () => import('./com-side-box');
const ComDownload = () => import('./com-download');
const ComBtnEncryption = () => import('./com-btn-encryption');

const TreePopover = () => import('./tree-popover');
const commonView = {
  install: () => {
    Vue.component('com-header', Header);
    Vue.component('com-userinfo', Userinfo);
    Vue.component('com-title-h1', ComTitleH1);
    Vue.component('com-tabs', ComTabs);
    Vue.component('img-head', ImgHead);
    Vue.component('com-table', ComTable);
    Vue.component('com-form-card', ComFormCard);
    Vue.component('single-upload-dialog', singleUploadDialog);
    Vue.component('brt-tooltip', brtTooltip);
    Vue.component('com-tag', ComTag);
    // Vue.component('svg-icon', SvgIcon)
    Vue.component('com-breadcrumb', comBreadcrumb);
    Vue.component('com-circular-ring', comCircularRing);
    Vue.component('com-search', comSearch);
    Vue.component('com-select-big', comSelectBig);
    Vue.component('sub-dividing', subDividing);
    Vue.component('com-scrollbar', comScrollbar);
    Vue.component('com-search-tag', comSearchTags);
    Vue.component('com-query', ComQuery);
    Vue.component('com-progress', ComProgress);
    Vue.component('com-operation', comOperation);
    Vue.component('com-tip-card', comTipCard);
    Vue.component('com-watermark', comWatermark);
    Vue.component('com-filter-list', ComFilterList);
    Vue.component('com-no-value', ComNoValue);
    Vue.component('com-message-box', ComMessageBox);
    Vue.component('super-query', SuperQuery);
    Vue.component('select-tree', SelectTree);
    Vue.component('com-sign-qrcode', ComSignQrcode);
    Vue.component('com-form', ComForm);
    Vue.component('com-query-panel', ComQueryPanel);
    Vue.component('com-select', ComSelect);
    Vue.component('com-side-box', ComSideBox);
    Vue.component('com-download', ComDownload);
    Vue.component('com-btn-encryption', ComBtnEncryption);
    Vue.component('tree-popover', TreePopover);
    // 公告
    Vue.component('AdEntry', (resolve) => require(['./adview/adEntry.vue'], resolve));
  }
};
export default commonView;
